import React from "react";
import PropTypes from "prop-types";
import { Helmet } from "react-helmet";
import CssBaseline from "@material-ui/core/CssBaseline";
import { ThemeProvider } from "@material-ui/core/styles";
import theme from "theme";
import store from "./apps/store";
import "resize-observer-polyfill";
import { Provider } from "react-redux";
import Amplify from "aws-amplify";
import awsconfig from "aws-exports";
import viewportUnitsBuggyfill from "viewport-units-buggyfill";

Amplify.configure({
  ...awsconfig,
  aws_appsync_authenticationType: "API_KEY",
});

type Props = {
  children: React.ReactNode;
};
// 100vh 修正
viewportUnitsBuggyfill.init({ force: true });

export default function TopLayout(props: Props) {
  return (
    <Provider store={store}>
      <Helmet>
        <meta
          name="viewport"
          content="minimum-scale=1, initial-scale=1, width=device-width"
        />
        <link
          href="https://fonts.googleapis.com/css?family=Roboto:400,500,700&display=swap"
          rel="stylesheet"
        />
        <link
          rel="stylesheet"
          href="https://fonts.googleapis.com/icon?family=Material+Icons"
        />
        <link
          href="https://use.fontawesome.com/releases/v5.12.0/css/all.css"
          rel="stylesheet"
        />
      </Helmet>
      <ThemeProvider theme={theme}>
        {/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
        <CssBaseline />
        {props.children}
      </ThemeProvider>
    </Provider>
  );
}

TopLayout.propTypes = {
  children: PropTypes.node,
};
